/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOxygen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M11 2c1.668 0 3 .444 3.896 1.417.88.958 1.174 2.25 1.174 3.583v9.97l.013.388c.018.383.061.749.207 1.053a.888.888 0 0 0 .344.395c.156.095.427.194.901.194.474 0 .746-.1.901-.194a.887.887 0 0 0 .344-.395c.195-.406.205-.92.22-1.44v-2.703L17.402 11.5a1 1 0 0 1 .725-1.49l.14-.01h3.465a1 1 0 0 1 .866 1.5L21 14.268v2.761c-.011.398-.001 1.383-.416 2.247a2.88 2.88 0 0 1-1.107 1.239c-.534.324-1.184.485-1.942.485s-1.408-.161-1.941-.485a2.885 2.885 0 0 1-1.108-1.239c-.414-.864-.404-1.849-.416-2.247V7c0-1.08-.241-1.79-.645-2.229C13.035 4.35 12.33 4 11 4H8v1.126c1.725.444 3 2.01 3 3.874v9a4 4 0 0 1-7.995.206L3 18V9a4.002 4.002 0 0 1 3-3.874V4H4.5V2zM5 17v1a2 2 0 1 0 4 0v-1zm0-1h4v-5H5zm2-9a2 2 0 0 0-2 2v1h4V9a2 2 0 0 0-2-2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgOxygen as Oxygen };
